const macroStreamModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl: '/modules/pis-tool/triggers/macro-stream-modal/macro-stream-modal.html',
  controller: 'MacroStreamModalController',
};

angular
  .module('pis-tool.module')
  .component('macroStreamModal', macroStreamModal);
